import RequesterSecurity from "../requesters/security.js";

export default {
  methods: {
    checkIfAuthorized: async function ({ role, permission, entity }) {
      await RequesterSecurity.authorized(role, permission, entity);
    }
  }
};
